const isImgWithinDimensions = (height, width, threshold) => {
    if ((width > height || width == height) && width < threshold) {
        return false;
    } else if (height > width && height < threshold) {
        return false;
    } else {
        return true;
    }
};
export {isImgWithinDimensions};
